var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"dark":"","color":_vm.appConfig.color,"inset":_vm.appConfig.footer.inset,"app":""}},[_c('span',{staticClass:"px-4 font-weight-bold"},[_vm._v("© "+_vm._s(new Date().getFullYear())+" CONSERVATIVE")])])}
var staticRenderFns = []

export { render, staticRenderFns }